import { Button, ComposedModal, ModalBody } from '@carbon/react';
import ModalStateManager from "../../Modal/index.js";
import { useTranslation } from "react-i18next";

const LogoutModal = ({ isOpen, onClose, onLogout }) => {
  const { t } = useTranslation();
  const modalService = ModalStateManager({
    children: (
      <ComposedModal
        className="logout-modal"
        open={isOpen}
        onClose={onClose}
        size="md"
      >
        <ModalBody>
          <div className="logout-modal__panel">
            <h2>{t("header.logoutQuestion")}</h2>

            <div className="logout-modal__actions">
              <Button kind="danger" size="md" onClick={onClose}>
                {t("common.cancel")}
              </Button>

              <Button kind="primary" size="md" onClick={onLogout}>
                {t("navigation.logout")}
              </Button>
            </div>
          </div>
        </ModalBody>
      </ComposedModal>
    )
  });

  return modalService;
};

export default LogoutModal;
